import { OnSendDeleteConfirmation } from '~/features/events';
import { sendDeleteConfirmation } from '~/features/utils';
import {
  GetAvailablePrivilegesDoneEvent,
  OnCreateMultipleDoneEvent,
  OnDeleteMultipleEvent,
  PrivilegeMachineEvents,
} from './events';
import { PrivilegeMachineContext, PrivilegesFormValues } from './types';

export const setLoading = {
  loading: true,
};

export const resetLoading = {
  loading: false,
};

export const sendContextToCrud = ({ context }: { context: PrivilegeMachineContext }) => {
  context.crudRef.send({
    type: 'ON_SEND_SHARED_CONTEXT',
    values: { providerId: context.providerId },
  });
};

export const sendLoadToCrud = ({ context }: { context: PrivilegeMachineContext }) => {
  context.crudRef.send({ type: 'ON_LOAD' });
};

export const setAvailablePrivileges = ({ event }: { event: PrivilegeMachineEvents }) => {
  return {
    availablePrivileges: (event as GetAvailablePrivilegesDoneEvent).output,
  };
};

export const setIdsToDelete = ({ event }: { event: PrivilegeMachineEvents }) => {
  return {
    idsToDelete: (event as OnDeleteMultipleEvent).payload.ids,
  };
};

export const removePrivilegesFromCrudContext = ({
  context,
}: {
  context: PrivilegeMachineContext;
  event: PrivilegeMachineEvents;
}) => {
  const currentData = context.crudRef.getSnapshot().context.data;
  const newData = currentData.filter(
    (privilege: PrivilegesFormValues) => !context.idsToDelete.includes(privilege.id as number)
  );
  context.crudRef.send({
    type: 'ON_SEND_SHARED_CONTEXT',
    values: {
      data: newData,
    },
  });
};

export const addPrivilegesToCrudContext = ({
  context,
  event,
}: {
  context: PrivilegeMachineContext;
  event: PrivilegeMachineEvents;
}) => {
  const currentData = context.crudRef.getSnapshot().context.data;
  const newData = [...currentData, ...(event as OnCreateMultipleDoneEvent).output];
  context.crudRef.send({
    type: 'ON_SEND_SHARED_CONTEXT',
    values: {
      data: newData,
    },
  });
};

export const openConfirmation = ({
  context,
  event,
  system,
}: {
  context: PrivilegeMachineContext;
  event: PrivilegeMachineEvents;
  system: { get: (id: string) => { send: (event: unknown) => void } };
}) => {
  const deleteEvent = event as OnSendDeleteConfirmation;
  const onConfirm = (id: number) => {
    // Send ON_DELETE to crudRef (which handles the actual delete)
    context.crudRef.send({ type: 'ON_DELETE', payload: { id } });
  };
  system.get('userState').send(sendDeleteConfirmation(() => onConfirm(deleteEvent.payload.id)));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openBulkDeleteConfirmation = (args: any) => {
  const { context, system, self } = args;
  const ids = context.idsToDelete;
  if (ids.length === 0) return;
  const onConfirm = () => {
    // Use self to send event back to this machine
    self.send({ type: 'ON_CONFIRMED_DELETE_MULTIPLE', payload: { ids } });
  };
  system.get('userState').send(sendDeleteConfirmation(onConfirm));
};

export const creatingCustom = {
  creatingCustom: true,
};

export const resetCreatingCustom = {
  creatingCustom: false,
};
